import { LicenseExpiredAlertMessage } from "@rl-appliances/component-library";
import { BrowserTitle } from "../../../components/BrowserTitle";
import { AxiosApiWrapper } from "../../../services/api/AxiosApiWrapper";
import { PAGE_TITLE } from "../../../titles";

const api = new AxiosApiWrapper();

const LicenseExpiredContainer = () => (
  <BrowserTitle title={PAGE_TITLE.LICENSE_EXPIRED}>
    <div className={"Licensing--container LicensingExpired--container"}>
      <LicenseExpiredAlertMessage onLogoutClick={() => api.logout()} />
    </div>
  </BrowserTitle>
);

export default LicenseExpiredContainer;
